var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsername2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / Icon / User-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Icon-/-User-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounds",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,19.5 L17.5,19.5 L17.5,15 C17.5,13.0670034 15.9329966,11.5 14,11.5 L8,11.5 C6.06700338,11.5 4.5,13.0670034 4.5,15 L4.5,19.5 Z",
    id: "Shape",
    stroke: "#FF085C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,9.5 C12.9329966,9.5 14.5,7.93299662 14.5,6 C14.5,4.06700338 12.9329966,2.5 11,2.5 C9.06700338,2.5 7.5,4.06700338 7.5,6 C7.5,7.93299662 9.06700338,9.5 11,9.5 Z",
    id: "Shape",
    stroke: "#FF085C",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsername2);
export default __webpack_public_path__ + "static/media/username2.f79c0f4ff46dd1a964f026e28377f50b.svg";
export { ForwardRef as ReactComponent };